/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import moment from 'moment';
import queryString from 'query-string';

import { Box, Button, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber, periodSearchSelectItems, ROLE } from 'data/data';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import {  getEquipmentAlertsByQueryString, getEquipmentAlertsGroupCountByFllwActionType } from 'components/axios/equipmentAlertsAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import ConstantInspectionFollowActionTypeRequestLayer from 'components/layer/ConstantInspectionFollowActionTypeRequestLayer';
import CommonExcelDownload from "components/CommonExcelDownload";
import PageInfo from 'components/PageInfo';

const EquipmentAlertHistoryTrackingMonitoring = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, role } = useEnumApi();
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [equipmentAlerts, setEquipmentAlerts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    
    const [equipmentFollowActionType, setEquipmentFollowActionType] = useState('');
    const [equipmentAlertStatus, setEquipmentAlertStatus] = useState('');
    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [periodSearch, setPeriodSearch] = useState('');
    const [alertType, setAlertType] = useState('');
    const [alertCategory, setAlertCategory] = useState('');
   
    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    const excelTitle = t('menu.cmms.equipment-alert-history-tracking');
    const excelTopHeaders = [t('message.common.subtitle.status'), t('message.common.subtitle.fieldChkedAt'), t('message.common.subtitle.fllwActionType'), 
        t('message.common.subtitle.alertedAt'), t('message.common.subtitle.alertType'), t('message.common.subtitle.alertCategory'), 
        // t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station.name'),
        t('message.common.subtitle.equipment.level2'), t('message.common.subtitle.equipment.level3'), 
        t('message.common.subtitle.equipment.name'), t('message.common.subtitle.equipment.number')];
    const fileName = excelTitle+"_"+Date.now();
    const [excelDatas, setExcelDatas] = useState([]);

    const toDate = new Date();

    const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
  
    let qs = queryString.parse(window.location.search);

    let followActionTypeSelectColor = "";
    if (equipmentFollowActionType === '' || equipmentFollowActionType === "sum") {
      followActionTypeSelectColor = " selected";
    }
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
    
    let columns = [];
    if (role === ROLE.MO.code) {
      columns = [
        { field: 'status', headerName: t('message.common.subtitle.status'), sortable:true, width: 80
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.status === 'D' ? 'condition1' : params.row?.status === 'F' ? 'condition3' : params.row?.status === 'M' ? 'condition4' : ''}>
              <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", params.row?.status)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'fieldChkedAt', headerName: t('message.common.subtitle.fieldChkedAt'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.fieldChkedAt && dayjs(params.row?.fieldChkedAt).format('YYYY-MM-DD HH:mm')}</Link>)
        },
        { field: 'fllwActionType', headerName: t('message.common.subtitle.fllwActionType'), sortable:true, width: 80
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.fllwActionType === 'O1_WAIT' ? 'condition1' : params.row?.fllwActionType === 'O2_OBSERVE' ? 'condition3' 
            : params.row?.fllwActionType === 'O3_MNT' ? 'condition5' : params.row?.fllwActionType === 'O4_NORMAL' ? 'condition6' : ''}>
              <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("FollowActionType", params.row?.fllwActionType)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'latestAlertedAt', headerName: t('message.common.subtitle.alertedAt'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.latestAlertedAt && dayjs(params.row?.latestAlertedAt).format('YYYY-MM-DD HH:mm')}</Link>)
        },
        { field: 'alertType', headerName: t('message.common.subtitle.alertType'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertType", params.row?.alertType)?.[0]?.title}</Link>)
        },
        { field: 'alertCategory', headerName: t('message.common.subtitle.alertCategory'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertCategory", params.row?.alertCategory)?.[0]?.title}</Link>)
        },
        // { field: 'equipment.station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 100
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("SubwayLine", params.row?.equipment?.station?.workingPart?.subwayLine)?.[0]?.title}</Link>)
        // },
        // { field: 'equipment.station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.workingPart?.name}</Link>)
        // },
        // { field: 'equipment.station.name', headerName: t('message.common.subtitle.station.name'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.name}</Link>)
        // },
        { field: 'equipment.equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.name}</Link>)
        },
        { field: 'equipment.equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.name}</Link>)
        },
        { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
        },
        { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
        }
      ];
    } else {
      columns = [
        { field: 'status', headerName: t('message.common.subtitle.status'), sortable:true, width: 80
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.status === 'D' ? 'condition1' : params.row?.status === 'F' ? 'condition3' : params.row?.status === 'M' ? 'condition4' : ''}>
              <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", params.row?.status)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'fieldChkedAt', headerName: t('message.common.subtitle.fieldChkedAt'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.fieldChkedAt && dayjs(params.row?.fieldChkedAt).format('YYYY-MM-DD HH:mm')}</Link>)
        },
        { field: 'fllwActionType', headerName: t('message.common.subtitle.fllwActionType'), sortable:true, width: 80
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.fllwActionType === 'O1_WAIT' ? 'condition1' : params.row?.fllwActionType === 'O2_OBSERVE' ? 'condition3' 
            : params.row?.fllwActionType === 'O3_MNT' ? 'condition5' : params.row?.fllwActionType === 'O4_NORMAL' ? 'condition6' : ''}>
              <Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("FollowActionType", params.row?.fllwActionType)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'latestAlertedAt', headerName: t('message.common.subtitle.alertedAt'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.latestAlertedAt && dayjs(params.row?.latestAlertedAt).format('YYYY-MM-DD HH:mm')}</Link>)
        },
        { field: 'alertType', headerName: t('message.common.subtitle.alertType'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertType", params.row?.alertType)?.[0]?.title}</Link>)
        },
        { field: 'alertCategory', headerName: t('message.common.subtitle.alertCategory'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertCategory", params.row?.alertCategory)?.[0]?.title}</Link>)
        },
        // { field: 'equipment.station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 100
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("SubwayLine", params.row?.equipment?.station?.workingPart?.subwayLine)?.[0]?.title}</Link>)
        // },
        // { field: 'equipment.station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.workingPart?.name}</Link>)
        // },
        // { field: 'equipment.station.name', headerName: t('message.common.subtitle.station.name'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.station?.name}</Link>)
        // },
        { field: 'equipment.equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.name}</Link>)
        },
        { field: 'equipment.equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.name}</Link>)
        },
        { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
        },
        { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment-alert-history-tracking/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
        },
        {
          field: 'constantInspection', headerName: t('message.common.subtitle.constantInspection'), sortable:false, width: 100
          , renderCell:(params)=>(params.row?.status === 'D' && <div style={{textAlign:"center", width:"100%"}}><ConstantInspectionFollowActionTypeRequestLayer alertId={params.row?.id} setIsLoading={setIsLoading} type="icon" /></div>)
        }
      ];
    }

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);
      
      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "status,asc"});
        searchOrders.push({sort : "latestAlertedAt,desc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page)};
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchStatus) setEquipmentAlertStatus(qs.searchStatus);
        if (qs.searchFollowActionType) setEquipmentFollowActionType(qs.searchFollowActionType);
        if (qs.searchAlertType) setAlertType(qs.searchAlertType);
        if (qs.searchAlertCategory) setAlertCategory(qs.searchAlertCategory);
        // if (qs.searchSubway) setSubwayCode(qs.searchSubway);
        // if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
        // if (qs.searchStation) setStationId(qs.searchStation);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);
        if (qs.periodSearch >= 0) setPeriodSearch(qs.periodSearch);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchFollowActionType) {searchParamCopy.searchFollowActionType = qs.searchFollowActionType};
        if (qs.searchAlertType) {searchParamCopy.searchAlertType = qs.searchAlertType};
        if (qs.searchAlertCategory) {searchParamCopy.searchAlertCategory = qs.searchAlertCategory};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchWorkingPart) {searchParamCopy.searchWorkingPart = qs.searchWorkingPart};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.periodSearch >= 0) {searchParamCopy.periodSearch = qs.periodSearch};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchStatus
      , qs.searchAlertType, qs.searchAlertCategory
      // , qs.searchFollowActionType, qs.searchSubway, qs.searchWorkingPart, qs.searchStation, qs.periodSearch
      , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);
    
    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //   if (subwayCode) {
    //     const param = {"subwayLine" : subwayCode, size:50}
    //     getWorkingPartsByQuery(param).then((data)=>{
    //       if (data && data._embedded) {
    //         let workingParts = data._embedded.workingParts;
    //         setWorkingParts(workingParts);
    //       } else {
    //         setWorkingParts([]);
    //       }
    //       setStations([]);
    //     });
    //   }
    // },[subwayCode]);
  
    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //   if (workingPartId) {
    //     const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
    //     getStationsByQuery(param).then((data)=>{
    //       if (data && data._embedded) {
    //         setStations(data._embedded.stations);
    //       } else {
    //         setStations([]);
    //       }
    //     });
    //   }
    // },[workingPartId]);
  
    // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
        });
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        });
      }
    },[equipmentCategoryLevel2Id]);
  
    // 목록
    useEffect(()=> {
      if ((!isLoading || sortModel != null) && !isNaN(currentPage) && getEnumValueByEnumName("FollowActionType") && isParam) {
        equipmentAlertList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize, isParam, getEnumValueByEnumName("FollowActionType"), sortModel]);
    
    let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
    let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
    
    const equipmentAlertList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  
      let param = {
          page : curPage,
          size : pageSize,
          "equipment.iotInstlYn" : true,
          AlertType:"IOT"
      };
      let countParam = {...param};
      if (equipmentAlertStatus) {
          param.status = equipmentAlertStatus;
      }
      if (equipmentFollowActionType != 'sum') {
          param.fllwActionType = equipmentFollowActionType;
      }
      if (alertType) {
          param["alertType"] = alertType;
      }
      if (alertCategory) {
          param["alertCategory"] = alertCategory;
      }
      // if (subwayCode) {
      //     param["equipment.station.workingPart.subwayLine"] = subwayCode;
      // }
      // if (workingPartId) {
      //     param['equipment.station.workingPart.id'] = workingPartId;
      // }
      // if (stationId) {
      //     param['equipment.station.id'] = stationId;
      // }
      if (equipmentCategoryLevel1Id) {
          param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }
      if (equipmentCategoryLevel2Id) {
          param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }
      if (equipmentCategoryLevel3Id) {
          param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }
      let keyword = searchKeyword;
      if (searchKeyword) {
          if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
              keyword = 'contains('+searchKeyword+')';
          }

          if (searchField === 'name') {
              param['equipment.name'] = 'contains('+searchKeyword+')';
          } else if (searchField === 'equipmentNo') {
              param['equipment.equipmentNo'] = 'contains('+searchKeyword+')';
          }
      }
      let addQueryString = "";
      if (equipmentAlertStatus === null || equipmentAlertStatus === '') {
        addQueryString += "&status=D&status=F&status=M";
      }
      if (sortModel && sortModel.length > 0)
        addQueryString = "&sort="+sortModel[0].field+","+sortModel[0].sort;
      else
        addQueryString += "&sort=status,asc&sort=latestAlertedAt,desc";
        
      if (periodSearch !== '' && periodSearch >= 0) {
        if (periodSearch % 5 === 0)
          addQueryString += "&latestAlertedAt=gte("+encodeURIComponent(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), 0, 1)).format())+")&latestAlertedAt=and(lte("+encodeURIComponent(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), 12, 0, 23 , 59, 59)).format())+"))";
        else {
          addQueryString += "&latestAlertedAt=gte("+encodeURIComponent(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), (((periodSearch%5)-1)*3), 1)).format())+")&latestAlertedAt=and(lte("+encodeURIComponent(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), ((periodSearch%5)*3), 0, 23 , 59, 59)).format())+"))";
        }
      }
      let queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
      queryString += addQueryString;
      Promise.all([
        getEquipmentAlertsByQueryString("?"+queryString).then((data)=>{
            if (data != null) {
              if(data.page) {
                  setPageInfo(data.page);
              } else {
                  setCurrentPage(0);
                  pageInfo = {
                  size : pageInfo.size,
                  totalElements : 0,
                  totalPages : 0,
                  number : 0
                  }
                  setPageInfo(pageInfo);
              }
              if(data._embedded) {
                  setEquipmentAlerts(data._embedded.equipmentAlerts);
                  setIsLoading(true);
                  return data.page.totalElements;
              } else {
                  setEquipmentAlerts([]);
              }
            } else {
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
              setEquipmentAlerts([]);
            }
            setIsLoading(true);
            return 0;
        }),
        getEquipmentAlertsGroupCountByFllwActionType(countParam).then((res)=>{
          equipmentGroupCounts = [];
          totalEquipmentGroupCount = 0;
          if (res != null) {
            let isInclude = false;
            let statussData = res.data;
    
            let followActionTypes = getEnumValueByEnumName("FollowActionType");
            if (followActionTypes) {
                followActionTypes.map(status => status.code === 'O1_WAIT' ? status.sort = 1 : '')
                followActionTypes.map(status => status.code === 'O4_NORMAL' ? status.sort = 2 : '')
                followActionTypes.map(status => status.code === 'O2_OBSERVE' ? status.sort = 3 : '')
                followActionTypes.map(status => status.code === 'O3_MNT' ? status.sort = 4 : '')
                orderNumber(followActionTypes, "sort")
  
                followActionTypes.map(function(item1) {
                isInclude = false;
                statussData.map(function(item2) {
                  if (item2.id === item1.code) {
                    equipmentGroupCounts.push(...[item2]);
                    totalEquipmentGroupCount += item2.count;
                    isInclude = true;
                  }
                })
    
                if (!isInclude) {
                  let defaultStatus = [{
                    name : item1.code,
                    id : item1.code,
                    title : item1.title,
                    count : 0,
                  }];
                  equipmentGroupCounts.push(...defaultStatus);
                }
              })
            }
            setEquipmentGroupCounts(equipmentGroupCounts);
            setTotalEquipmentGroupCount(totalEquipmentGroupCount);
          }
        })
      ]).then((res)=>{
        delete param.page;
        param.page = 0;
        const totalCount = res[0];
        if (totalCount) {
          delete param.size;
          param.size = totalCount;
          queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
          queryString += addQueryString;
          getEquipmentAlertsByQueryString("?"+queryString).then((data)=>{
            if (data != null) {
              if(data._embedded) {
                let list = data._embedded.equipmentAlerts;
                let excelDatas = [];
                let excelData = [];
                list && list.forEach(function (column, a) {
                  excelData = [
                      ((getEnumValueByEnumNameAndCode("EquipmentAlertStatus", column.status)?.[0]?.title) || ''),
                      ((column.fieldChkedAt && dayjs(column.fieldChkedAt).format('YYYY-MM-DD HH:mm')) || ''),
                      ((getEnumValueByEnumNameAndCode("FollowActionType", column.fllwActionType)?.[0]?.title) || ''),
                      ((column.latestAlertedAt && dayjs(column.latestAlertedAt).format('YYYY-MM-DD HH:mm')) || ''),
                      ((getEnumValueByEnumNameAndCode("AlertType", column.alertType)?.[0]?.title) || ''),
                      ((getEnumValueByEnumNameAndCode("AlertCategory", column.alertCategory)?.[0]?.title) || ''),
                      // ((getEnumValueByEnumNameAndCode("SubwayLine", column.equipment?.station?.workingPart?.subwayLine)?.[0]?.title) || ''),
                      // ((column.equipment?.station?.workingPart?.name) || ''),
                      // ((column.equipment?.station?.name) || ''),
                      ((column.equipment?.equipmentCtgr?.parent?.name) || ''),
                      ((column.equipment?.equipmentCtgr?.name) || ''),
                      ((column.equipment?.name) || ''),
                      ((column.equipment?.equipmentNo) || '')
                  ];
                  excelDatas.push(excelData);
                });
                setExcelDatas(excelDatas);
              } else {
                setExcelDatas([]);
              }
            } else {
              setExcelDatas([]);
            }
          })
        } else {
          setExcelDatas([]);
        }
      })
      setIsLoading(true);
    }
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
  
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      equipmentAlertList(0);
      setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (equipmentFollowActionType) {searchParamCopy.searchFollowActionType = equipmentFollowActionType};
      if (alertType) {searchParamCopy.searchAlertType = alertType};
      if (alertCategory) {searchParamCopy.searchAlertCategory = alertCategory};
      if (equipmentAlertStatus) {searchParamCopy.searchStatus = equipmentAlertStatus};
      // if (subwayCode) {searchParamCopy.searchSubway = subwayCode};
      // if (workingPartId) {searchParamCopy.searchWorkingPart = workingPartId};
      // if (stationId) {searchParamCopy.searchStation = stationId};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      if (periodSearch >= 0) {searchParamCopy.periodSearch = periodSearch};
      
      setSearchParam(searchParamCopy)

      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event)
      handleClose();
    };

    const statusTapSearch = (vCode) => {
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      setEquipmentFollowActionType(vCode);
      initSearch();

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      searchParamCopy.searchFollowActionType = vCode;
      searchParamCopy.searchKeyword = '';
      searchParamCopy.searchStatus = '';
      searchParamCopy.searchSubway = '';
      searchParamCopy.searchWorkingPart = '';
      searchParamCopy.searchStation = '';
      searchParamCopy.searchlevel1 = '';
      searchParamCopy.searchlevel2 = '';
      searchParamCopy.searchlevel3 = '';
      searchParamCopy.periodSearch = '';
      searchParamCopy.alertType = '';
      searchParamCopy.alertCategory = '';
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };
  
    const initSearch = ()  => {
      setEquipmentAlertStatus('');
      // setSubwayCode('');
      // setWorkingPartId('');
      // setStationId('');
      setEquipmentCategoryLevel1Id('');
      setEquipmentCategoryLevel2Id('');
      setEquipmentCategoryLevel3Id('');
      setPeriodSearch('');
      setAlertType('');
      setAlertCategory('');
      setSearchKeyword('');
      setCurrentPage(0);
      setIsLoading(false);
      setExcelDatas([]);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };

    return (
      <div className="sub_container">
          <ul className='condition' style={{marginTop:"px"}}>
            <li className={`sum${followActionTypeSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalEquipmentGroupCount}</li>
            {equipmentGroupCounts &&
              equipmentGroupCounts.map(function(item, i) {
                followActionTypeSelectColor = "";
                if (item.id === equipmentFollowActionType) {
                  followActionTypeSelectColor = " selected";
                }
                return (
                  <li key={i} className={`${item.id}${followActionTypeSelectColor}`} onClick={() => statusTapSearch(item.id)} style={{cursor:"pointer"}}>{item.title}: {item.count}</li>      
                )
              }) }
          </ul>
          
          <div className="selectbox">
            <div className="desktop_serach">
                <Box component="form">
                <div>
                {getEnumValueByEnumName("EquipmentAlertStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentAlertStatus}
                      label={t('message.common.subtitle.status')}
                      labelName={t('message.common.subtitle.status')}
                      name={'equipmentAlertStatus'}
                      defaultValue={equipmentAlertStatus}
                      onChange={(e)=>{
                        setEquipmentAlertStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentAlertStatus")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("AlertType") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={alertType}
                      label={t('message.common.subtitle.alertType')}
                      labelName={t('message.common.subtitle.alertType')}
                      name={'alertType'}
                      defaultValue={alertType}
                      onChange={(e)=>{
                        setAlertType(e.target.value);
                      }}
                      list={getEnumValueByEnumName("AlertType")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("AlertCategory") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={alertCategory}
                      label={t('message.common.subtitle.alertCategory')}
                      labelName={t('message.common.subtitle.alertCategory')}
                      name={'alertCategory'}
                      defaultValue={alertCategory}
                      onChange={(e)=>{
                        setAlertCategory(e.target.value);
                      }}
                      list={getEnumValueByEnumName("AlertCategory")}
                  />
                  </FormControl>
                  }
                  {/* {getEnumValueByEnumName("FollowActionType") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentFollowActionType}
                      label={t('message.common.subtitle.fllwActionType')}
                      labelName={t('message.common.subtitle.fllwActionType')}
                      name={'equipmentFollowActionType'}
                      defaultValue={equipmentFollowActionType}
                      onChange={(e)=>{
                        setEquipmentFollowActionType(e.target.value);
                      }}
                      list={getEnumValueByEnumName("FollowActionType")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("SubwayLine") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={subwayCode}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={subwayCode}
                      onChange={(e)=>{
                        setSubwayCode(e.target.value);
                        setWorkingPartId('');
                        setStationId('');
                      }}
                      list={getEnumValueByEnumName("SubwayLine")}
                  />
                  </FormControl>
                  }
                  {workingParts && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={workingPartId}
                      label={t('message.common.subtitle.workingPart')}
                      labelName={t('message.common.subtitle.workingPart')}
                      name={'workPart'}
                      defaultValue={workingPartId}
                      onChange={(e)=>{
                        setWorkingPartId(e.target.value);
                        setStationId('');
                      }}
                      list={workingParts}
                  />
                  </FormControl>
                  }
                  {stations && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={stationId}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      defaultValue={stationId}
                      onChange={(e)=>{
                        setStationId(e.target.value);
                      }}
                      list={stations}
                  />
                  </FormControl>
                  } */}
                  {equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  {/* {periodSearchSelectItems && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={periodSearch}
                      label={t('message.common.select.alertPeriod')}
                      labelName={t('message.common.select.alertPeriod')}
                      name={'periodSearch'}
                      defaultValue={periodSearch}
                      onChange={(e)=>{
                        setPeriodSearch(e.target.value);
                      }}
                      list={periodSearchSelectItems}
                  />
                  </FormControl>
                  } */}
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>
  
                    <Button variant="contained" style={{marginTop:"0",padding:"10px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                    </div>
                </div>
                </Box>
            </div>

            <div className="mobile_serach" style={{display:"none"}}>
                <Button style={{width:"100%",marginBottom:"10px"}} variant="contained" color="secondary" onClick={handleClickOpen}>
                    {t('message.common.text.search.category.open')}
                </Button>
                <Dialog className="mobile_serach_box" disableEscapeKeyDown open={open} onClose={handleClose}>
                    <DialogTitle>{t('message.common.text.search.category.select')}</DialogTitle>
                    <DialogContent>
                    <Box component="form">
                        <div>
                        {getEnumValueByEnumName("EquipmentAlertStatus") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={equipmentAlertStatus}
                            label={t('message.common.subtitle.status')}
                            labelName={t('message.common.subtitle.status')}
                            name={'equipmentAlertStatus'}
                            defaultValue={equipmentAlertStatus}
                            onChange={(e)=>{
                                setEquipmentAlertStatus(e.target.value);
                            }}
                            list={getEnumValueByEnumName("EquipmentAlertStatus")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("AlertType") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={alertType}
                            label={t('message.common.subtitle.alertType')}
                            labelName={t('message.common.subtitle.alertType')}
                            name={'alertType'}
                            defaultValue={alertType}
                            onChange={(e)=>{
                              setAlertType(e.target.value);
                            }}
                            list={getEnumValueByEnumName("AlertType")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("AlertCategory") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={alertCategory}
                            label={t('message.common.subtitle.alertCategory')}
                            labelName={t('message.common.subtitle.alertCategory')}
                            name={'alertCategory'}
                            defaultValue={alertCategory}
                            onChange={(e)=>{
                              setAlertCategory(e.target.value);
                            }}
                            list={getEnumValueByEnumName("AlertCategory")}
                        />
                        </FormControl>
                        }
                        {/* {getEnumValueByEnumName("FollowActionType") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={equipmentFollowActionType}
                            label={t('message.common.subtitle.fllwActionType')}
                            labelName={t('message.common.subtitle.fllwActionType')}
                            name={'equipmentFollowActionType'}
                            defaultValue={equipmentFollowActionType}
                            onChange={(e)=>{
                                setEquipmentFollowActionType(e.target.value);
                            }}
                            list={getEnumValueByEnumName("FollowActionType")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("SubwayLine") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={subwayCode}
                            label={t('message.common.subtitle.subwayline')}
                            labelName={t('message.common.subtitle.subwayline')}
                            name={'subway'}
                            defaultValue={subwayCode}
                            onChange={(e)=>{
                                setSubwayCode(e.target.value);
                                setWorkingPartId('');
                                setStationId('');
                            }}
                            list={getEnumValueByEnumName("SubwayLine")}
                        />
                        </FormControl>
                        }
                        {workingParts && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={workingPartId}
                            label={t('message.common.subtitle.workingPart')}
                            labelName={t('message.common.subtitle.workingPart')}
                            name={'workPart'}
                            defaultValue={workingPartId}
                            onChange={(e)=>{
                                setWorkingPartId(e.target.value);
                                setStationId('');
                            }}
                            list={workingParts}
                        />
                        </FormControl>
                        }
                        {stations && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={stationId}
                            label={t('message.common.subtitle.station')}
                            labelName={t('message.common.subtitle.station')}
                            name={'station'}
                            defaultValue={stationId}
                            onChange={(e)=>{
                                setStationId(e.target.value);
                            }}
                            list={stations}
                        />
                        </FormControl>
                        } */}
                        {equipmentCategoryLevel1s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel1Id}
                            label={t('message.common.subtitle.equipment.level1')}
                            labelName={t('message.common.subtitle.equipment.level1')}
                            name={'level1'}
                            defaultValue={equipmentCategoryLevel1Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel1Id(e.target.value);
                                setEquipmentCategoryLevel2Id('');
                                setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel1s}
                        />
                        </FormControl>
                        }
                        {equipmentCategoryLevel2s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel2Id}
                            label={t('message.common.subtitle.equipment.level2')}
                            labelName={t('message.common.subtitle.equipment.level2')}
                            name={'level2'}
                            defaultValue={equipmentCategoryLevel2Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel2Id(e.target.value);
                                setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel2s}
                        />
                        </FormControl>
                        }
                        {equipmentCategoryLevel3s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomSelect
                            key={equipmentCategoryLevel3Id}
                            label={t('message.common.subtitle.equipment.level3')}
                            labelName={t('message.common.subtitle.equipment.level3')}
                            name={'level3'}
                            defaultValue={equipmentCategoryLevel3Id}
                            onChange={(e)=>{
                                setEquipmentCategoryLevel3Id(e.target.value);
                            }}
                            list={equipmentCategoryLevel3s}
                        />
                        </FormControl>
                        }
                        {periodSearchSelectItems && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={periodSearch}
                            label={t('message.common.select.alertPeriod')}
                            labelName={t('message.common.select.alertPeriod')}
                            name={'periodSearch'}
                            defaultValue={periodSearch}
                            onChange={(e)=>{
                              setPeriodSearch(e.target.value);
                            }}
                            list={periodSearchSelectItems}
                        />
                        </FormControl>
                        }
                        <div style={{display:"inline-block"}}>
                        {searchFields && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                            <CustomEnumSelect
                            key={searchField}
                            label={t('message.common.btn.search')}
                            labelName={t('message.common.btn.search')}
                            name={'searchField'}
                            defaultValue={searchField}
                            onChange={(e)=>{
                                setSearchField(e.target.value);
                            }}
                            list={searchFields}
                        />
                        </FormControl>
                        }
                            <FormControl sx={{ m: 1 }} variant="standard">
                            <BootstrapInput id="demo-customized-textbox" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleMobileOnKeyPress}/>
                            </FormControl>
                        </div>
                    </div>
                    </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleMobileSearch} variant="contained">{t('message.common.btn.search')}</Button>
                        <Button onClick={handleClose} variant="contained" color="secondary">{t('message.common.btn.cancel')}</Button>
                    </DialogActions>
                </Dialog>
            </div>
          </div>

          <Box id="tableDiv">
            <DataGridPro
              rows={equipmentAlerts && equipmentAlerts !== undefined ? equipmentAlerts : []}
              columns={columns}
              disableColumnFilter
              sortModel={sortModel || []}
              onSortModelChange={setSortModel}
              sx={{
                "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                  display: "none",
                },
                "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
              }}
            />
          </Box>

          <div className="btn_right">
              {(excelDatas && excelDatas.length > 0) ?
              <div className='no-print-page'>
                  <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${excelTitle}`} filename={`${fileName}.xlsx`} />
              </div>
              :
              (equipmentAlerts && equipmentAlerts.length > 0) ?
              <div className='no-print-page' style={{color:"#FFF"}}>
                <Box sx={{ display: 'flex', color:"#FFF" }}>
                  {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                </Box>
              </div>
              : ''
              }
          </div>
          
          <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

      </div>
    );
}

export default EquipmentAlertHistoryTrackingMonitoring;